__turbopack_context__.v({
  "content": "ProductInfo-module-scss-module__CooLdq__content",
  "info-block": "ProductInfo-module-scss-module__CooLdq__info-block",
  "info-blocks-layout": "ProductInfo-module-scss-module__CooLdq__info-blocks-layout",
  "product-info-section": "ProductInfo-module-scss-module__CooLdq__product-info-section",
});
